import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { authAPI } from '../api';
import { t } from '../i18n';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();
  const [uid, setUid] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Prefer path params if present, otherwise fall back to query params
    const rawUid = (params && params.uid) ? params.uid : (searchParams.get('uid') || '');
    const rawToken = (params && params.token) ? params.token : (searchParams.get('token') || '');

    const cleanUid = (p) => {
      if (!p) return p;
      let s = p;
      s = s.replace(/=3D/g, '=').replace(/3D/g, '=');
      s = s.replace(/\s+/g, '');
      try { s = decodeURIComponent(s); } catch (e) { }
      while (s.length % 4 !== 0) s += '=';
      return s;
    };

    const cleanToken = (p) => {
      if (!p) return p;
      let s = p;
      s = s.replace(/=3D/g, '=').replace(/3D/g, '=');
      s = s.replace(/\s+/g, '');
      try { s = decodeURIComponent(s); } catch (e) { }
      return s;
    };

    setUid(cleanUid(rawUid));
    setToken(cleanToken(rawToken));
  }, [searchParams, params]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (newPassword !== confirmPassword) {
      setError(t('passwordsDoNotMatch'));
      return;
    }

    try {
      const res = await authAPI.passwordResetConfirm({ uid, token, new_password: newPassword });
      setMessage(res.data?.detail || t('passwordResetSuccessfully'));
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || t('failedToResetPassword'));
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '50px auto' }}>
        <h2>{t('resetPassword')}</h2>
        {message && <div style={{ color: 'green', marginBottom: '10px' }}>{message}</div>}
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('newPassword')}</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          <div className="form-group">
            <label>{t('confirmNewPassword')}</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          <button type="submit" className="btn btn-primary">{t('setNewPassword')}</button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
